var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomePartnersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9062 28.9072L22.9062 32.9072C23.3002 33.3012 23.7679 33.6137 24.2827 33.8269C24.7974 34.0401 25.3491 34.1499 25.9062 34.1499C26.4634 34.1499 27.0151 34.0401 27.5298 33.8269C28.0446 33.6137 28.5123 33.3012 28.9062 32.9072C29.3002 32.5133 29.6127 32.0456 29.8259 31.5308C30.0392 31.0161 30.1489 30.4644 30.1489 29.9072C30.1489 29.3501 30.0392 28.7984 29.8259 28.2836C29.6127 27.7689 29.3002 27.3012 28.9062 26.9072",
    stroke: "white",
    strokeWidth: 1.81217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9067 22.9073L29.9067 27.9073C30.7024 28.7029 31.7815 29.1499 32.9067 29.1499C34.0319 29.1499 35.1111 28.7029 35.9067 27.9073C36.7024 27.1116 37.1493 26.0325 37.1493 24.9073C37.1493 23.782 36.7024 22.7029 35.9067 21.9073L28.1467 14.1473C27.0217 13.0237 25.4967 12.3925 23.9067 12.3925C22.3167 12.3925 20.7917 13.0237 19.6667 14.1473L17.9067 15.9073C17.1111 16.7029 16.0319 17.1499 14.9067 17.1499C13.7815 17.1499 12.7024 16.7029 11.9067 15.9073C11.1111 15.1116 10.6641 14.0325 10.6641 12.9073C10.6641 11.782 11.1111 10.7029 11.9067 9.90726L17.5267 4.28726C19.3512 2.46755 21.7305 1.30836 24.288 0.993202C26.8455 0.678044 29.435 1.22492 31.6467 2.54726L32.5867 3.10726C33.4383 3.62123 34.4508 3.79949 35.4267 3.60726L38.9067 2.90726",
    stroke: "white",
    strokeWidth: 1.81217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9062 0.906738L40.9062 22.9067H36.9062",
    stroke: "white",
    strokeWidth: 1.81217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90625 0.906738L0.90625 22.9067L13.9062 35.9067C14.7019 36.7024 15.781 37.1494 16.9062 37.1494C18.0315 37.1494 19.1106 36.7024 19.9062 35.9067C20.7019 35.1111 21.1489 34.032 21.1489 32.9067C21.1489 31.7815 20.7019 30.7024 19.9062 29.9067",
    stroke: "white",
    strokeWidth: 1.81217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90625 2.90674H18.9062",
    stroke: "white",
    strokeWidth: 1.81217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePartnersIcon);
export default __webpack_public_path__ + "static/media/home-Partners-icon.6fbda6a7a24892c7774f0711a5b49296.svg";
export { ForwardRef as ReactComponent };